import { render, staticRenderFns } from "./RegClient.vue?vue&type=template&id=0c0a6c71&scoped=true"
import script from "./RegClient.vue?vue&type=script&lang=js"
export * from "./RegClient.vue?vue&type=script&lang=js"
import style0 from "./RegClient.vue?vue&type=style&index=0&id=0c0a6c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a6c71",
  null
  
)

export default component.exports